import { AgentType } from '@server/ai';
import { Popover, Stack } from '@mui/material';
import { Button } from '@sweep-io/sweep-design';
import useAgentsToRender from './useAgentsToRender';
import CreateNewAgentCard from './CreateNewAgentCard';
import { UserSupportAgentCard } from './userSupport/UserSupportAgentCard';

const NewAgentButton = ({
  onNewAgentClick,
  anchorRef,
  openPopover,
  isPopoverOpen,
  anchorElement,
  closePopover,
}: {
  onNewAgentClick: (type: AgentType) => void;
  openPopover: () => void;
  closePopover: () => void;
  isPopoverOpen: boolean;
  anchorElement: Element;
  anchorRef: React.MutableRefObject<any>;
}) => {
  const agentsToRender = useAgentsToRender();
  const { creatableAgentTypes, creatableAgentTypesNoSub, singletonAgentsNoSub } =
    agentsToRender ?? {};

  if (!agentsToRender) {
    return null;
  }

  const agentTypesList = creatableAgentTypes?.concat(creatableAgentTypesNoSub ?? []);

  if (!agentTypesList) {
    return null;
  }

  return (
    <>
      <Button
        ref={anchorRef}
        size="small"
        variant="secondary"
        startIconName="Plus"
        onClick={(e) => {
          e.stopPropagation();
          openPopover();
        }}
        pressed={isPopoverOpen}
      >
        Create New
      </Button>
      <Popover
        open={isPopoverOpen}
        anchorEl={anchorElement}
        onClose={closePopover}
        slotProps={{
          paper: {
            sx: {
              width: '400px',
            },
          },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Stack padding={2} gap="12px">
          {agentTypesList.map((type) => {
            const isNotSubscribed = !!creatableAgentTypesNoSub?.find(
              (nonSubscribedType) => nonSubscribedType === type,
            );
            return (
              <CreateNewAgentCard
                key={type}
                agentType={type}
                onClick={(e) => {
                  if (isNotSubscribed) {
                    return;
                  }
                  e?.stopPropagation();
                  onNewAgentClick(type);
                  closePopover();
                }}
                isNotSubscribed={isNotSubscribed}
              />
            );
          })}
          {/* user support card in popover has to be visible when its dialog is rendered - card is the anchor */}
          <UserSupportAgentCard section="launch" onCreateConnection={closePopover} />
          {singletonAgentsNoSub?.map((agent) => (
            <CreateNewAgentCard key={agent.id} agentType={agent.type} isNotSubscribed={true} />
          ))}
        </Stack>
      </Popover>
    </>
  );
};

export default NewAgentButton;
